<template lang="pug">

	div.row#bottomBar
		
		.col-4
			base-map-select

		.col-4
			coordinates.d-flex.justify-content-center

		.col-4
			div.float-right
				zoom-select

</template>

<script>

import BaseMapSelect from '@/components/BaseMapSelect';
import Coordinates from '@/components/Coordinates';
import ZoomSelect from '@/components/ZoomSelect';

export default {
	
	name: 'BottomBar',

	components: { BaseMapSelect, Coordinates, ZoomSelect }
};

</script>

<style lang="scss">

@import "../styles/mixins.scss";
@import '../styles/variaveis';

#bottomBar {

	position: absolute;
	cursor: default;
	background: $bottom-bar-bg;
	border-top-left-radius: $default-border-radius;
	border-top-right-radius: $default-border-radius;
	width: $bottom-bar-width;
	height: $bottom-bar-height;
	margin-left: ($bottom-bar-width / 2) * -1;
	@include box-shadow(0px, 3px, 6px, rgba(0,0,0,0.16));
	z-index: 1000;
	bottom: 0;
	left: 50%;
	font-size: $bottom-bar-font-size;

	.fa.fa-angle-up {
		transition-duration: 0.3s;
		transition-property: transform;
		transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
	}

	.active {

		color: $base-map-select-active-color;
		
		.fa.fa-angle-up {
			transition-duration: 0.3s;
			transition-property: transform;
			transform: rotate(180deg);
			-webkit-transform: rotate(180deg);
		}
	}
}

</style>



// WEBPACK FOOTER //
// BottomBar.vue?2be6eaf9